import { render } from 'react-dom';
import { I18nextProvider } from 'react-i18next';
// Import UI Components
import GeneUIProvider from '@geneui/components/GeneUIProvider';
// Import i18n
import i18n from './i18n';
// Import Store
import { StoreProvider } from 'store';
// Import Styles
import 'reactflow/dist/style.css';
import './index.scss';
// Import Components
import { App } from 'components';
import Router from './BrowserRouterWrapper';

render(
    <StoreProvider>
        <Router>
            <I18nextProvider i18n={i18n}>
                <GeneUIProvider>
                    <App />
                </GeneUIProvider>
            </I18nextProvider>
        </Router>
    </StoreProvider>,
    document.getElementById('root'),
);
